<template>
    <el-dialog
        title="重要！暂停升级通知"
        :visible.sync="dialogVisible"
        width="1000px"
        :before-close="handleClose"
        :close-on-click-modal="false"
    >
        <div class="content">
            <p>亲爱的用户：</p>
            <div>
                为了更好地为您服务，即日起，58问卷平台将进行优化升级，升级期间功能将暂不可用：
                <br />2022年2月16日起，问卷创建、复制功能不可用，其余功能可正常使用。
                <br />2022年3月1日起，所有功能不可使用。
                <br />开放时间另行通知，请您提前做好数据备份。
                <br />如需要反馈和帮助，请<span style="color:#ff552d;cursor: pointer;" @click="contactUs">联系我们</span>。
                <br />（58内部用户可直接联系OA：hanxiaoting）
            </div>
            <div class="team">
                <p>
                    58问卷团队
                    <br />2022年1月14日
                </p>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
        }
    },
    methods: {
        handleClose(done) {
            done();
        },
        contactUs() {
            window.open("https://survey.58.com/?id=1027681&hash=gdry");
        }
    }
}
</script>

<style lang="scss">
.el-dialog__wrapper {
    font-family: PingFangSC-Regular;
    .el-dialog {
        height: 476px;
        padding: 0 30px;
        background: linear-gradient(
            180deg,
            rgba(255, 242, 237, 1) 0%,
            rgba(255, 255, 255, 1) 21%,
            rgba(255, 255, 255, 1) 100%
        );
        position: relative;
        .el-dialog__header {
            padding-top: 50px;
            .el-dialog__title {
                font-size: 24px;
                font-weight: 400;
                line-height: 24px;
                color: rgba(51, 51, 51, 1);
            }
            .el-dialog__headerbtn {
                top: 50px;
                right: 50px;
                font-size: 20px;
            }
        }
        .el-dialog__body {
            .content {
                font-size: 16px;
                font-weight: 400;
                line-height: 25px;
                color: rgba(102, 102, 102, 1);
                position: relative;
                p {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 18px;
                    color: rgba(51, 51, 51, 1);
                    padding-top: 10px;
                    padding-bottom: 20px;
                }
                .team {
                    width: 200px;
                    height: 100px;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 30px;
                    color: rgba(51, 51, 51, 1);
                    position: absolute;
                    right: 0;
                    bottom: -70px;
                    background-image: url("https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/bc3kpm91.png");
                    p {
                        display: inline-block;
                        line-height: 30px;
                        padding: 0;
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        text-align: right;
                    }
                }
            }
        }
        .el-dialog__footer {
            position: absolute;
            width: 940px;
            bottom: 0;
            padding-bottom: 32px;
            display: flex;
            justify-content: center;
            .dialog-footer {
                .el-button {
                    width: 188px;
                    height: 36px;
                    background-image: none;
                    background-color: #ff552d;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/interimDialog.vue